export default "__VITE_ASSET__RXnfP1Mv__"